import React from 'react';
import { StyleSheet } from 'react-native';
import { CreditReportTrackDebtsCard } from 'features/credit-score/components/CreditReportOfferCards';
import { selectShouldShowTrackDebtsCard } from 'features/credit-score/selectors';
import { useAppSelector } from 'store/hooks';
import { isWeb } from '../../../../constants';
const NetWorthTrackDebtsCard = ({ onTrackingDone }) => {
    const shouldShow = useAppSelector(selectShouldShowTrackDebtsCard);
    if (!shouldShow)
        return null;
    return (<CreditReportTrackDebtsCard source="netWorth" style={styles.card} withMarginBottom onTrackingDone={onTrackingDone}/>);
};
const styles = StyleSheet.create({
    card: {
        ...(isWeb && { marginHorizontal: 0 }),
    },
});
export default NetWorthTrackDebtsCard;
